import Tabs from './src/tabs';

Tabs.install = function(Vue) {
  Vue.component(Tabs.name, Tabs);
};

export default Tabs;



// WEBPACK FOOTER //
// ./src/components/tabs/index.js